import * as React from 'react';
import DialogContent from '@material-ui/core/DialogContent';

const CustomDialogContent = React.forwardRef((props, ref) => {
    return <DialogContent ref={ref} {...props} />;
});

export { CustomDialogContent as DialogContent };
